import Vue from 'vue'
import HkjToast from './HkjToast.vue'
 
let noticInstance = null,
    NoticeConstructor = Vue.extend(HkjToast),
    init = () => {
        noticInstance = new NoticeConstructor()
        noticInstance.$mount()
        document.body.appendChild(noticInstance.$el)
    },
    caller = (opt) => {
        if (!noticInstance) {
            init()
        }
        noticInstance.show(opt)
    }
 
export default {
    // 返回 install 函数 用于 Vue.use 注册
    install(vue) {
        vue.prototype.$showToast = caller
    },
}